import { NavLink, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Header.scss";
import whiteLogo from "../../../assets/logos/HUM-AI-Logo-Full-Mark-White.svg";
import blackLogo from "../../../assets/logos/HUM-AI-Logo-Full-Mark-Black.svg";
import { useTheme } from "../../../context/ThemeContext";
import blackMenuIcon from "../../../assets/icons/menu/black-menu.svg";
import whiteMenuIcon from "../../../assets/icons/menu/white-menu.svg";
import MobileMenu from "../MobileMenu/MobileMenu";

function Header({ CLOUDFRONT_URL }) {
  const { theme } = useTheme();
  const [hasScrolled, setHasScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setHasScrolled(scrollPosition > 0);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Choose the logo based on theme
  const logo = theme.logoVariant === "black" ? blackLogo : whiteLogo;
  const menuIcon =
    theme.logoVariant === "black" ? blackMenuIcon : whiteMenuIcon;

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className={`header ${hasScrolled ? "header--scrolled" : ""}`}
        style={hasScrolled ? { backgroundColor: theme.backgroundColor } : {}}
      >
        <div className="header__content">
          <Link to="/" className="header__logo-link">
            <img src={logo} alt="HUM AI Logo" className="header__logo" />
          </Link>
          <img
            src={menuIcon}
            alt="Menu"
            className="header__burger-menu-icon"
            onClick={toggleMobileMenu}
          />
          <nav className="header__nav">
            <ul className="header__list">
              <li className="header__list-item">
                <NavLink className="header__link" to="/">
                  home
                </NavLink>
              </li>
              {/* <li className="header__list-item">
                <NavLink className="header__link" to="/blog">
                  blog
                </NavLink>
              </li> */}
              <li className="header__list-item">
                <NavLink className="header__link" to="/research">
                  research
                </NavLink>
              </li>
              <li className="header__list-item">
                <NavLink className="header__link" to="https://jobs.ashbyhq.com/hum-ai/">
                  careers
                </NavLink>
              </li>
              <li className="header__list-item">
                <NavLink className="header__link" to="mailto:founders@hum.ai">
                  contact
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <MobileMenu
        isOpen={mobileMenuOpen}
        onClose={closeMobileMenu}
        CLOUDFRONT_URL={CLOUDFRONT_URL}
      />
    </>
  );
}

export default Header;
